<template>
  <AccountOpePanel>
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0 h6">{{ $t("下载您的产品") }}</h5>
      </div>
      <div class="card-body">
        <table
          class="table aiz-table mb-0 footable footable-1 breakpoint-xs"
          style=""
        >
          <thead>
            <tr class="footable-header">
              <th style="display: table-cell">{{ $t("产品") }}</th>
              <th style="display: table-cell" width="20%">
                {{ $t("选项") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="footable-empty">
              <td colspan="2">{{ $t("什么都没找到") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </AccountOpePanel>
</template>
<script>
import AccountOpePanel from "@/components/AccountOpePanel.vue";

export default {
  components: {
    AccountOpePanel
  }
};
</script>
